import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className='auth_main-ctr'>
      <Outlet />
    </div>
  );
};

export default AuthLayout;
